import React, { ReactNode } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from '@ygtechnologies/bygr-frontend-component-library';
import { triggerHandler } from '@ygtechnologies/rubus-frontend-utilities';
import { Trans } from '@lingui/react/macro';
import { Button } from '@/components/Buttons';
import { ButtonColor } from '@/components/Buttons/ButtonElement';
import { TranslatableText } from '@/types';

interface YesNoDialogProps {
    title: ReactNode;
    body: ReactNode;
    show: boolean;
    onAccept(): void;
    onClose(): void;
    onCancel?(): void;
    confirmButtonColor?: ButtonColor;
    cancelButtonColor?: ButtonColor;
    confirmButtonText?: TranslatableText;
    cancelButtonText?: TranslatableText;
    disableAccept?: boolean;
    disableReason?: ReactNode;
    /**
     * This is the "x" on top right
     */
    onCloseClick?(): void;
}

const YesNoDialog: React.FC<YesNoDialogProps> = ({
    title,
    body,
    show,
    onAccept,
    onClose,
    onCancel,
    onCloseClick = onCancel,
    confirmButtonColor = 'primary',
    cancelButtonColor = 'tertiary',
    confirmButtonText = <Trans>Yes</Trans>,
    cancelButtonText = <Trans>No</Trans>,
    disableAccept = false,
    disableReason
}) => {
    const handleAcceptClick = () => {
        triggerHandler(onAccept);
        triggerHandler(onClose);
    };

    const handleCancelClick = () => {
        triggerHandler(onCancel);
        triggerHandler(onClose);
    };

    return (
        <Modal isOpen={show} toggle={onCloseClick}>
            <ModalHeader>{title}</ModalHeader>
            <ModalBody>{body}</ModalBody>
            <ModalFooter>
                <Button color={cancelButtonColor} onClick={handleCancelClick}>
                    {cancelButtonText}
                </Button>
                <Button tooltip={disableAccept ? disableReason : undefined} disabled={disableAccept} color={confirmButtonColor} onClick={handleAcceptClick}>
                    {confirmButtonText}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default YesNoDialog;